import DefaultTemplate from "../layout/content-templates/default/DefaultTemplate.tsx";
import styles from "./Home.module.scss";
import HomeFeatures from "./widgets/HomeFeatures.tsx";
import RecentBooks from "./widgets/RecentBooks.tsx";
import ReaderTips from "./widgets/ReaderTips.tsx";
import DashboardBanners from "./widgets/DashboardBanners.tsx";
import PromoRow from "./widgets/PromoRow.tsx";
import OffScreen from "../../../common/core-ui/OffScreen.tsx";
import { useIntl } from "react-intl";
import PaddedDotLoader from "../search/common/PaddedDotLoader.tsx";
import { Suspense } from "react";
import { useRecentBooksLoaderData } from "./dashboardLoader.ts";
import DefaultError from "../../../common/core-ui/DefaultError.tsx";
import { Await } from "react-router-dom";
import PageTitle from "../common/page-title/PageTitle.tsx";
import FreeBooks from "./widgets/FreeBooks.tsx";

export default function Home() {
  const loaderData = useRecentBooksLoaderData();
  const intl = useIntl();
  const title = intl.formatMessage({ defaultMessage: "Home" });

  return (
    <>
      <DefaultTemplate title={title}>
        <div className={styles.container}>
          {/* Prefer putting show/hide decisions inside individual widgets */}
          <DashboardBanners />
          <OffScreen>
            <PageTitle title={title} />
          </OffScreen>
          <Suspense fallback={<PaddedDotLoader />}>
            <Await resolve={loaderData} errorElement={<DefaultError />}>
              {(response: Awaited<typeof loaderData>) => {
                if (response.ok && response.data) {
                  const total = response.meta?.page?.totals.items ?? 0;
                  return (
                    <>
                      <RecentBooks books={response.data} total={total} />
                      <HomeFeatures bookCount={total} />
                    </>
                  );
                }
              }}
            </Await>
          </Suspense>
          <PromoRow />
          <FreeBooks />
          <ReaderTips />
        </div>
      </DefaultTemplate>
    </>
  );
}
